import * as Popover from '@radix-ui/react-popover';
import clsx from 'clsx';
import { ChevronDownIcon } from 'src/svgs/Viagogo';

import { PresetOption } from '../StrategyCalculatorPanel.types';
import * as styles from './PresetPills.css';

export const PresetPills = <T extends string>({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: PresetOption<T>[];
  value: T;
  onChange: (value: T) => void;
}) => {
  return (
    <div className={styles.container}>
      <span className={styles.label}>{label}</span>
      <div className={styles.pillGroup} role="radiogroup" aria-label={label}>
        {options.map((option) => (
          <button
            key={option.value}
            className={clsx(styles.pill, {
              [styles.pillActive]: option.value === value,
            })}
            role="radio"
            aria-checked={option.value === value}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export const MobilePresetChip = <T extends string>({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: PresetOption<T>[];
  value: T;
  onChange: (value: T) => void;
}) => {
  const selectedLabel = options.find((o) => o.value === value)?.label ?? '';

  return (
    <div className={styles.mobileContainer}>
      <span className={styles.label}>{label}</span>
      <Popover.Root>
        <Popover.Trigger asChild>
          <button
            className={styles.mobileChipTrigger}
            aria-label={`${label} ${selectedLabel}`}
          >
            {selectedLabel}
            <span className={styles.mobileChipIcon}>
              <ChevronDownIcon width={12} height={12} />
            </span>
          </button>
        </Popover.Trigger>
        <Popover.Portal>
          <Popover.Content
            className={styles.mobilePopoverContent}
            sideOffset={4}
            align="start"
          >
            {options.map((option) => (
              <Popover.Close key={option.value} asChild>
                <button
                  className={clsx(styles.mobilePopoverItem, {
                    [styles.mobilePopoverItemActive]: option.value === value,
                  })}
                  onClick={() => onChange(option.value)}
                >
                  {option.label}
                </button>
              </Popover.Close>
            ))}
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>
    </div>
  );
};
